import { useEffect, useState } from "react";
import Confetti from "@/pages/ladder/components/Confetti";
import { HANDS, handEmoji, handFull, resultText } from "../utils";

interface Props {
  hostHand: string;
  hostHandTxt?: string;
  result: string;
  resultTxt?: string;
  reward?: string;
  hasReward?: boolean;
  onDone: () => void;
}

// 내가 마지막 자리를 채웠을 때의 결과 연출.
// 1) ✊✌️🖐️ 를 0.15초 간격으로 1초간 번갈아 보여준다.
// 2) 등록자 손을 «탁» 하고 확정한다.
// 3) 승패를 크게 보여준다. 이겼으면 색종이.
export default function HandReveal({
  hostHand,
  hostHandTxt,
  result,
  reward,
  hasReward,
  onDone,
}: Props) {
  const [phase, setPhase] = useState<"rolling" | "host" | "result">("rolling");
  const [frame, setFrame] = useState(0);

  useEffect(() => {
    const roll = window.setInterval(
      () => setFrame((f) => (f + 1) % HANDS.length),
      150
    );
    const t1 = window.setTimeout(() => {
      window.clearInterval(roll);
      setPhase("host");
    }, 1000);
    const t2 = window.setTimeout(() => setPhase("result"), 1650);
    return () => {
      window.clearInterval(roll);
      window.clearTimeout(t1);
      window.clearTimeout(t2);
    };
  }, []);

  const win = result === "W";
  const hostEmoji = handEmoji(hostHand) || "✊";

  return (
    <div
      className="fixed inset-0 z-[250] flex items-center justify-center p-4"
      role="dialog"
      aria-modal="true"
    >
      <div className="absolute inset-0 bg-primary-950/70" aria-hidden="true"></div>

      <div className="relative z-10 w-full max-w-sm overflow-hidden rounded-2xl bg-background-50 px-6 py-8 text-center shadow-xl">
        {win && phase === "result" && <Confetti />}

        <p className="text-sm font-semibold text-foreground-500">등록자의 손</p>

        <div className="mt-3 flex h-28 items-center justify-center">
          {phase === "rolling" ? (
            <span className="rps-shake text-6xl leading-none" aria-hidden="true">
              {HANDS[frame].emoji}
            </span>
          ) : (
            <span className="rps-pop text-6xl leading-none" aria-hidden="true">
              {hostEmoji}
            </span>
          )}
        </div>

        {phase !== "rolling" && (
          <p className="mt-1 font-heading text-lg font-bold text-foreground-900">
            {handFull(hostHand, hostHandTxt)}
          </p>
        )}

        {phase === "result" && (
          <>
            <p
              className={`mt-4 font-heading text-2xl font-extrabold ${
                win
                  ? "text-accent-700"
                  : result === "D"
                    ? "text-foreground-700"
                    : "text-foreground-800"
              }`}
            >
              {resultText(result)}
            </p>

            {win && hasReward && reward ? (
              <div className="mt-4 rounded-xl border border-accent-300 bg-accent-50 px-4 py-3 text-sm font-semibold text-accent-900">
                🎁 보상 : {reward}
              </div>
            ) : null}

            <button
              type="button"
              onClick={onDone}
              className="mt-6 w-full whitespace-nowrap rounded-md bg-primary-500 px-4 py-3 text-sm font-bold text-background-50 hover:bg-primary-600"
            >
              확인
            </button>
          </>
        )}
      </div>
    </div>
  );
}